// import React from 'react';
import { graphql } from 'gatsby';
import '@fortawesome/fontawesome-svg-core/styles.css';
import React, { useContext, useEffect } from 'react';
import FooterV2 from '@components/FooterV2/index';
import CrackedCrioCareersSection from '@components/v5/CrackedCrioCareersSection/index';
import ProjectsSection from '@components/v5/ProjectsSection/index';
import VideoTestimonialSection from '@components/v5/VideoTestimonialSection/index';
import CrioComparisionSection from '@components/v5/CrioComparisionSection/index';
import FAQSection from '@components/v5/FAQSection/index';
import WhyCrioSection from '@components/v5/WhyCrioSection/index';
import CrioButton from '@components/v5/CrioButton/index';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import { Link } from 'gatsby';
import { ERoutes } from '@src/constants/routes/index';
import { EProgramIDs } from '@src/constants/data/programs/index';
import SaleMiddleStrip from '@components/v5/Sale/SaleMiddleStrip';
import { stripData } from '@components/Sale/data';
import StatsPanelFSP from '@components/v5/StatsPanelFSP/index';
import FspPricingCardSection from '@components/v5/FspPricingCardSection/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import {
  LEAD_GEN_HOME_PROJECTS,
  LEAD_GEN_DEVELOPERS_CRACKED,
  // LEAD_GEN_WHY_CRIO,
  LEAD_GEN_PROJECTS,
  // LEAD_GEN_PROGRAM_STEPS,
  LEAD_GEN_CAREER_ASSISTANCE,
  LEAD_GEN_TESTIMONIALS,
  LEAD_GEN_CRIO_COMPARISION,
  LEAD_GEN_CURRICULUM_PRICING_CARD,
  LEAD_GEN_PROGRAM_ID_SKILLQ_FULL_STACK_DEVELOPMENT,
  LEAD_GEN_PROGRAM_ID_SKILLQ_DATA_ANALYTICS,
  LEAD_GEN_PROGRAM_ID_SKILLQ_QA_AUTOMATION,
  // LEAD_GEN_COMPANIES,
  // LEAD_GEN_PLAN_SECTION,
} from '../constants/LeadGenerationConstants/index';
import { useWebEngage } from '@src/hooks/useWebEngage';
import { GlobalStateContext } from '@src/context/GlobalContextProvider';
import { ELeadSquaredActivityCode } from '@src/constants/leadsquaredActivityConstants/index';
import { GTM } from '@src/analytics/gtm';
// import PersonalizedPlan from '@components/v5/PersonalizedPlan/index';
// import TechnologiesMasterSection from '@components/v5/TechnologiesMasterSection/index';
import fsp from '../seo/jsonld/fsd.json';
// import fdt from '../seo/jsonld/fdt.json';
// import bdt from '../seo/jsonld/bdt.json';
// import dataScienceJsonLd from '../seo/jsonld/data-science.json';
import { gtmEvents } from '@src/analytics/gtmEventsConstant';
import useCrioStat from '@src/hooks/useCrioStats';
import useDataScienceProgram from '@src/hooks/useDataScienceProgram';
import CurriculumV4 from '@components/v5/CurriculumV4';
import SkillSection from '@components/v5/SkillSection';
import { curriculumData as skillQFullStackCurriculumData } from '@src/constants/skillQFullStackCurriculumData';
import { curriculumData as skillQDataAnalyticsCurriculumData } from '@src/constants/skillQDataAnalyticsCurriculumData';
import { curriculumData as skillQQaAutomationCurriculumData } from '@src/constants/skillQQaAutomationCurriculumData';
import BottomStrip from '@components/PPCNavbar/BottomStrip';
import MentorTestimonialsSection from '@components/MentorSection';
import useSendActivities from '@src/hooks/useSendActivities';
import AiSkillDevelopmentPageHero from '@components/v5/AiSkillDevelopment/index';
import HeroStatsPanel from '@components/v5/AiSkillDevelopment/HeroStatsPanel';
import CompaniesSection from '@components/v5/CompaniesSection';
import PrebookCard from '@components/PrebookCard';
import CertificateImage from '@components/PrebookCard/CertificateImage';
import { useLocation } from '@reach/router';
import FormSubmitButton from '@components/LeadGenerationForm/FormComponents/FormSubmitButton';

export default function AiSkillDevelopmentPage(props) {
  const { captureUserClickEvent } = useWebEngage();
  const state = useContext(GlobalStateContext);

  const { isDataSciencePage } = useDataScienceProgram();
  const { sendActivityHandler } = useSendActivities();

  const location = useLocation();
  const isProvisionalEnrollment = location.pathname.includes(
    'provisional-enrollment',
  );

  const onPlacementButtonClick = () => {
    captureUserClickEvent('Get our Placement Stats', {
      placementLocation: 'FSP_PAGE',
    });

    sendActivityHandler(
      ELeadSquaredActivityCode.SD_PAGE_GET_OUR_PLACEMENT_STATS_CLICKED,
    );
  };
  const { data: queryData } = props;

  const { aiSkillDevelopmentPagesYaml: data } = queryData;
  console.log('🚀 ~ AiSkillDevelopmentPage ~ data:', data);
  // const program = props.data.allStrapiPrograms.nodes.find(
  //   (ele) => ele.PrimaryProgramID == data.PrimaryProgramID,
  // );

  // const programId = program?.PrimaryProgramID;
  const jsonLd = fsp;

  const sale = props.data.strapiSale.SaleID;

  const { placementStats } = useCrioStat();

  const isDataAnalyticsPage = location.pathname.includes(
    'skillq-data-analytics-program',
  );

  const isQaAutomationPage = location.pathname.includes(
    'skillq-qa-automation-program',
  );

  const getProjectsSectionPreContent = (sale) => {
    switch (sale) {
      case 'true':
        return (
          <div className="mx-4 mb-10 flex justify-center">
            <SaleMiddleStrip data={stripData[data.PrimaryProgramID]}>
              <LeadGenerationButton
                programType={programType}
                type="Book Your Trial, Now"
                buttonLocation={LEAD_GEN_HOME_PROJECTS}
              />
            </SaleMiddleStrip>
          </div>
        );

      default:
        return <></>;
    }
  };
  const isSkillQFullStack = data.slug.includes('full-stack');
  const isSkillQQaAutomation = data.slug.includes('qa-automation');
  const isSkillQDataAnalytics = !isSkillQFullStack && !isSkillQQaAutomation;

  const curriculumData = isSkillQFullStack
    ? skillQFullStackCurriculumData
    : isSkillQQaAutomation
    ? skillQQaAutomationCurriculumData
    : skillQDataAnalyticsCurriculumData;

  const programType = isSkillQFullStack
    ? LEAD_GEN_PROGRAM_ID_SKILLQ_FULL_STACK_DEVELOPMENT
    : isSkillQQaAutomation
    ? LEAD_GEN_PROGRAM_ID_SKILLQ_QA_AUTOMATION
    : LEAD_GEN_PROGRAM_ID_SKILLQ_DATA_ANALYTICS;

  useEffect(() => {
    //webengage events specific to FSD Page(experiment):
    GTM.track(gtmEvents.PAGE_VIEW_FSD, {
      type: data.PrimaryProgramID,
      slug: data.slug,
    });

    //GA EVENT FOR PAGE VIEW:
    GTM.track(gtmEvents.PAGE_VIEW, {
      type: data.PrimaryProgramID,
      slug: data.slug,
    });
  }, []);

  const ConfirmSeatButton = () => {
    return (
      <div className="flex items-center justify-center">
        <a className="" href="#top">
          <FormSubmitButton text={'Confirm Your Seat'} className={''} />
        </a>
      </div>
    );
  };

  return (
    <div>
      <div className="">
        <div className="text-v5-neutral-300" id="top">
          <AiSkillDevelopmentPageHero
            buttonText={
              isProvisionalEnrollment
                ? 'Pre Book Your Seat'
                : 'Book Your Trial, Now'
            }
          />
        </div>
      </div>

      {isProvisionalEnrollment ? (
        <>
          <PrebookCard />
          <CrioComparisionSection
            heading={<h1>How Crio SkillQ Stands Apart</h1>}
            isAiSkillDevelopmentPage={true}
            postContent={<ConfirmSeatButton />}
          ></CrioComparisionSection>{' '}
          <CertificateImage />
          <CurriculumV4
            heading={''}
            description={''}
            quote={data.curriculumQuote}
            type={data.PrimaryProgramID}
            curriculum={curriculumData.curriculum}
            advancedCurriculum={curriculumData.advancedCurriculum}
            dreamCompanies={data.dreamCompanies}
            superDreamCompanies={data.superDreamCompanies}
          />
          <div className="container py-10">
            <HeroStatsPanel isDataAnalytics={isSkillQDataAnalytics} />
          </div>
          <VideoTestimonialSection
            quote={data.testimonialQuote}
            disableCareerHandbook={
              data.PrimaryProgramID === EProgramIDs.QA_AUTOMATION_TESTING
            }
            postContent={
              <PostContentCTALayout className={'md:mt-2'}>
                <div className="">
                  <ConfirmSeatButton />
                </div>
              </PostContentCTALayout>
            }
          ></VideoTestimonialSection>
          <CompaniesSection
            postContent={
              <PostContentCTALayout className={'md:mt-10'}>
                <div>
                  <ConfirmSeatButton />
                </div>
              </PostContentCTALayout>
            }
          ></CompaniesSection>
        </>
      ) : (
        <>
          <div className="container">
            <HeroStatsPanel isDataAnalytics={isSkillQDataAnalytics} />
          </div>
          <CurriculumV4
            heading={''}
            description={''}
            quote={data.curriculumQuote}
            type={data.PrimaryProgramID}
            curriculum={curriculumData.curriculum}
            advancedCurriculum={curriculumData.advancedCurriculum}
            dreamCompanies={data.dreamCompanies}
            superDreamCompanies={data.superDreamCompanies}
          />
          <CrioComparisionSection
            heading={<h1>How Crio SkillQ Stands Apart</h1>}
            isAiSkillDevelopmentPage={true}
            postContent={
              <div className="-mt-12">
                <PostContentCTALayout>
                  <LeadGenerationButton
                    type="Book Your Trial, Now"
                    programType={programType}
                    buttonLocation={LEAD_GEN_CRIO_COMPARISION}
                  />
                </PostContentCTALayout>
              </div>
            }
          ></CrioComparisionSection>

          {!isDataSciencePage &&
            !data.slug.includes('skillq-data-analytics-program') && (
              <MentorTestimonialsSection />
            )}

          <CrackedCrioCareersSection
            postContent={
              <PostContentCTALayout>
                <div>
                  <div className="-mb-10">
                    <StatsPanelFSP
                      stats={placementStats.map((stat) => {
                        return {
                          title: stat.content,
                          subtitle: `${stat.label}`,
                        };
                      })}
                    ></StatsPanelFSP>
                  </div>
                  <PostContentCTALayout className="mb-10">
                    <Link to={ERoutes.PLACEMENTS}>
                      <CrioButton
                        variant="secondary"
                        onClick={onPlacementButtonClick}
                        className="h-[64px] w-[300px] border-v5-neutral-600 py-6 text-v5-neutral-600 sm:w-auto"
                      >
                        Get our Placement Stats
                      </CrioButton>
                    </Link>
                    <LeadGenerationButton
                      type="Book Your Trial, Now"
                      className="h-[64px] w-[300px]"
                      buttonLocation={LEAD_GEN_DEVELOPERS_CRACKED}
                      programType={programType}
                    />
                  </PostContentCTALayout>
                </div>
              </PostContentCTALayout>
            }
          ></CrackedCrioCareersSection>
          <SkillSection
            dreamCompanies={data.skills}
            heading={
              isDataAnalyticsPage
                ? 'Gain the competitive edge with mastery of essential data skills'
                : isQaAutomationPage
                ? 'Gain the competitive edge with mastery of essential testing skills'
                : 'Gain the competitive edge with mastery of essential development skills'
            }
            description={
              isDataAnalyticsPage
                ? 'Master leading tech skills like Python, SQL, Excel and Data Visualisation'
                : isQaAutomationPage
                ? 'Master leading tech skills like Java, Selenium, JUnit and SQL'
                : 'Master leading tech skills like Java, React JS, MongoDB, Kafka'
            }
          />

          <div className="min-h-[800px] py-10">
            <ProjectsSection
              heading={data.projectsTitle}
              description={data.projectsDescriptionV2}
              projects={data.projects}
              isAiSkillDevelopmentPage={true}
              postContent={
                <PostContentCTALayout>
                  <LeadGenerationButton
                    type="Book Your Trial, Now"
                    buttonLocation={LEAD_GEN_PROJECTS}
                    programType={programType}
                  />
                </PostContentCTALayout>
              }
              preContent={getProjectsSectionPreContent(sale)}
            ></ProjectsSection>
          </div>

          <CompaniesSection hideStats></CompaniesSection>

          <WhyCrioSection
            heading={data.careerTitleV2}
            description={data.careerDescription}
            data={data.careers}
            postContent={
              <PostContentCTALayout>
                <LeadGenerationButton
                  type="Book Your Trial, Now"
                  buttonLocation={LEAD_GEN_CAREER_ASSISTANCE}
                  programType={programType}
                />
              </PostContentCTALayout>
            }
          ></WhyCrioSection>

          <FspPricingCardSection
            price={data.price}
            duration={data.priceDuration}
            sale={sale}
            program={data?.PrimaryProgramID}
            postContent={
              <PostContentCTALayout>
                <LeadGenerationButton
                  type="Book Your Trial, Now"
                  buttonLocation={LEAD_GEN_CURRICULUM_PRICING_CARD}
                  programType={programType}
                />
              </PostContentCTALayout>
            }
          ></FspPricingCardSection>
          <VideoTestimonialSection
            quote={
              isDataSciencePage ? (
                <>
                  Get more insights on how Crio can help you{' '}
                  <br class="hidden sm:block" />
                  crack a data analytics role in top tech companies.
                </>
              ) : (
                data.testimonialQuote
              )
            }
            disableCareerHandbook={
              data.PrimaryProgramID === EProgramIDs.QA_AUTOMATION_TESTING
            }
            postContent={
              <PostContentCTALayout>
                <div className="-mt-16 xxs:-mt-10 sm:-mt-0">
                  <LeadGenerationButton
                    type="Book Your Trial, Now"
                    buttonLocation={LEAD_GEN_TESTIMONIALS}
                    programType={programType}
                  />
                </div>
              </PostContentCTALayout>
            }
          ></VideoTestimonialSection>
        </>
      )}
      <FAQSection data={data.faqs}></FAQSection>
      <FooterV2></FooterV2>
      <BottomStrip />
    </div>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    aiSkillDevelopmentPagesYaml(id: { eq: $id }) {
      PrimaryProgramID
      slug
      SEOTitle
      canonicalUrl
      SEODescription

      metatags {
        property
        content
      }

      heroTitle
      heroSubtitle
      heroDescription
      heroImage {
        childImageSharp {
          gatsbyImageData(
            width: 750
            quality: 80
            placeholder: DOMINANT_COLOR
            formats: [AUTO, WEBP]
          )
        }
      }

      statsSubtitle

      highlightsTitle
      highlights {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      highlightsV2 {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      projectsTitle
      projectsDescription
      projectsDescriptionV2
      projects {
        title
        subtitle
        tag
        image
        skills
      }

      careerTitle
      careerTitleV2
      careerDescription
      careers {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      curriculumTitle
      curriculumDescription
      curriculumQuote

      technologies {
        name
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      skills {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        originalImage {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      dreamCompanies {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        originalImage {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      superDreamCompanies {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        originalImage {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      curriculum {
        title
        image {
          childImageSharp {
            gatsbyImageData(
              width: 100
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        duration
        tag
        data
        skills
        anchor
        cardTitle
        cards {
          image {
            childImageSharp {
              gatsbyImageData(
                width: 300
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          data
          skills
          title
        }
      }

      curriculumfsd {
        basicCurriculumFSD {
          description
          duration
          title
          cards {
            description
            skills
            title
            subCards {
              description
              title
              skills
              spanToWidth
            }
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          subCards {
            description
            skills
            spanToWidth
            title
          }
          specializationType {
            numberOfCards
            title
          }
          description1
          description2
          skills
        }
        advancedCurriculumFSD {
          duration
          cards {
            description
            subCards {
              description
              skills
              spanToWidth
              title
              isCardLarge
            }
            title
            skills
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          title
          description
        }
        aspiringDeveloper {
          description
          duration
          title
          cards {
            description
            skills
            title
            subCards {
              description
              title
              skills
              spanToWidth
            }
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          subCards {
            description
            skills
            spanToWidth
            title
          }
          specializationType {
            numberOfCards
            title
          }
          description1
          description2
          skills
        }
        aspiringSeniorDeveloper {
          duration
          cards {
            description
            subCards {
              description
              skills
              spanToWidth
              title
              isCardLarge
            }
            title
            skills
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          title
          description
        }
      }

      advancedCurriculum {
        title
        image {
          childImageSharp {
            gatsbyImageData(
              width: 100
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        duration
        tag
        data
        skills
        cardTitle
        cards {
          image {
            childImageSharp {
              gatsbyImageData(
                width: 300
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          data
          skills
          title
        }
      }

      steps

      price
      priceDuration

      faqs {
        question
        answer
      }

      jobGuarantee {
        question
        answer
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
    ...strapiDataFragment
  }
`;
